<template>
  <form @submit.prevent="submit">
    <div class="mb-3 bg-gray-100" v-if="isCPU">
      <div class="p-2 flex justify-between items-center">
        <label
          for="cinebench"
          class="font-bold w-4/5 text-left flex items-center"
        >
          <span class="w-12 text-2xl text-gray-500">
            <font-awesome-icon :icon="['fas', 'rocket']"></font-awesome-icon>
          </span>
          <span v-text="i18n.cinebench.label"></span>
        </label>
        <div class="w-32">
          <safari-input
            min="1"
            step="any"
            class="text-right"
            type="number"
            name="cinebench"
            id="cinebench"
            v-model.number="score.cinebench"
            :required="!score.octanebench"
          />
        </div>
      </div>
      <p
        v-if="score.cinebench > 0 && score.cinebench < 100"
        class="text-sm pl-2 m-0 py-2 text-red-800 bg-orange-100"
        v-text="i18n.cinebench.too_low"
      />
      <p
        v-else-if="score.cinebench >= 10000"
        class="text-sm pl-2 m-0 py-2 text-red-800 bg-orange-100"
        v-text="i18n.cinebench.too_high"
      />
      <p
        v-else
        class="text-sm pl-2 text-gray-700 pb-1"
        v-html="i18n.cinebench.text"
      ></p>
    </div>
    <div class="mb-3 bg-gray-100" v-if="isGPU">
      <alert
        v-if="i18n.octanebench.octanebench_2020_alert"
        :message="i18n.octanebench.octanebench_2020_alert"
        level="success"
        class="px-5 my-3 text-sm"
      ></alert>
      <div class="p-2 flex justify-between items-center">
        <label
          for="octanebench"
          class="font-bold w-4/5 text-left flex items-center"
        >
          <span class="w-12 text-2xl text-gray-500">
            <font-awesome-icon :icon="['fas', 'rocket']"></font-awesome-icon>
          </span>
          <span v-text="i18n.octanebench.label"></span>
        </label>
        <div class="w-32">
          <safari-input
            min="1"
            step="any"
            class="text-right"
            type="number"
            name="octanebench"
            id="octanebench"
            v-model.number="score.octanebench"
            :required="!score.cinebench"
          />
        </div>
      </div>
      <p
        v-if="score.octanebench > 0 && score.octanebench < 50"
        class="text-sm pl-2 m-0 py-2 text-red-800 bg-orange-100"
        v-text="i18n.octanebench.too_low"
      />
      <p
        v-else-if="score.octanebench >= 5000"
        class="text-sm pl-2 m-0 py-2 text-red-800 bg-orange-100"
        v-text="i18n.octanebench.too_high"
      />
      <p
        v-else
        class="text-sm pl-2 text-gray-700 pb-1"
        v-html="i18n.octanebench.text"
      ></p>
    </div>
    <div class="bg-gray-100 p-2 flex justify-between items-center mb-3">
      <label for="images" class="font-bold w-4/5 text-left flex items-center">
        <span class="w-12 text-2xl text-gray-500"
          ><font-awesome-icon icon="images"></font-awesome-icon
        ></span>
        <span v-text="i18n.frame_number"></span>
      </label>
      <div class="w-32">
        <safari-input
          min="2"
          step="1"
          class="text-right"
          type="number"
          name="images"
          id="images"
          v-model.number="images"
          required
        />
      </div>
    </div>
    <div class="bg-gray-100">
      <div class="p-2 flex justify-between items-center">
        <label for="duration_h" class="font-bold text-left flex items-center">
          <span class="w-12 text-2xl text-gray-500">
            <font-awesome-icon icon="tachometer-alt"></font-awesome-icon>
          </span>
          <span v-text="i18n.frame_duration"></span>
        </label>
        <div class="">
          <div class="flex items-center">
            <div class="flex flex-col mx-1">
              <label
                for="duration_h"
                class="label px-1 text-sm text-center text-gray-700"
                v-text="i18n.hours"
              ></label>
              <safari-input
                class="w-16 text-right"
                type="number"
                placeholder=""
                id="duration_h"
                min="0"
                step="any"
                name="duration_h"
                v-model.number="duration.h"
              />
            </div>
            <div class="flex flex-col mx-1">
              <label
                for="duration_m"
                class="label px-1 text-sm text-center text-gray-700"
                v-text="i18n.minuts"
              ></label>
              <safari-input
                class="w-16 text-right"
                type="number"
                placeholder=""
                id="duration_m"
                min="0"
                step="any"
                name="duration_m"
                v-model.number="duration.m"
                :required="!seconds"
              />
            </div>
            <div class="flex flex-col ml-1">
              <label
                for="duration_s"
                class="label px-1 text-sm text-center text-gray-700"
                v-text="i18n.seconds"
              ></label>
              <safari-input
                class="w-16 text-right"
                type="number"
                placeholder=""
                id="duration_s"
                min="0"
                step="any"
                name="duration_s"
                v-model.number="duration.s"
              />
            </div>
          </div>
        </div>
      </div>
      <p
        class="text-sm px-2 pb-1 text-gray-700"
        v-text="i18n.average_duration"
      ></p>
    </div>
    <alert :message="i18n.precision" class="px-5 my-3 text-sm"></alert>
    <div class="flex justify-center mb-3">
      <button
        class="button button-base action-secondary flex justify-start items-center m-1"
        type="submit"
      >
        {{ i18n.estimate }}
      </button>
    </div>
  </form>
</template>

<script>
import SafariInput from "./SafariInput";
const storagePrefix = "estimation_score_";

export default {
  components: {
    SafariInput,
  },
  props: ["farms", "i18n"],
  created() {
    if (window.google_analytics_pageview) {
      window.google_analytics_pageview("/form-submit/tunnel/estimate");
    }
  },
  data() {
    return {
      score: {
        cinebench: localStorage.getItem(storagePrefix + "cpu") || undefined,
        octanebench:
          localStorage.getItem(storagePrefix + "gpu_2020") || undefined,
      },
      images: undefined,
      duration: {
        h: undefined,
        m: undefined,
        s: undefined,
      },
    };
  },
  watch: {
    $data: {
      handler() {
        this.submit();
      },
      deep: true,
    },
  },
  computed: {
    seconds() {
      return (
        (this.duration.s || 0) +
        60 * ((this.duration.m || 0) + 60 * (this.duration.h || 0))
      );
    },
    isCPU() {
      return this.farms.includes("power");
    },
    isGPU() {
      return this.farms.includes("gpu");
    },
    isComplete() {
      const gpuOk = this.isGPU && this.score.octanebench > 0;
      const cpuOk = this.isCPU && this.score.cinebench > 0;
      if (!gpuOk && !cpuOk) {
        return false;
      }
      if (!this.images || !this.seconds) {
        return false;
      }
      if (this.images <= 1 || this.seconds <= 0) {
        return false;
      }
      return true;
    },
  },
  methods: {
    saveSettings() {
      if (this.score.cinebench) {
        localStorage.setItem(storagePrefix + "cpu", this.score.cinebench);
      }
      if (this.score.octanebench) {
        localStorage.setItem(
          storagePrefix + "gpu_2020",
          this.score.octanebench
        );
      }
    },
    submit() {
      this.saveSettings();

      this.emit();
    },
    emit() {
      if (!this.isComplete) {
        this.$emit("input", null);
        return;
      }
      const data = {
        seconds: this.seconds,
        images: this.images,
        score: {},
      };
      if (this.score.cinebench > 0) {
        data.score.cinebench = this.score.cinebench;
      }
      if (this.score.octanebench > 0) {
        data.score.octanebench = this.score.octanebench;
      }
      this.$emit("input", data);
    },
  },
};
</script>
